/**
 * Shared emoji data with search keywords.
 * Used by EditConversationModal and ModuleEditModal.
 */
export const EMOJI_DATA: Array<{ emoji: string; keywords: string[] }> = [
  // Xavior Logo
  { emoji: ':xavior-logo:', keywords: ['xavior', 'logo', 'x', 'brand', 'app'] },

  // Common / Featured
  { emoji: '📁', keywords: ['folder', 'file', 'files', 'general', 'misc', 'default', 'documents'] },
  { emoji: '🏠', keywords: ['home', 'house', 'personal', 'family', 'life', 'residence'] },
  { emoji: '💼', keywords: ['work', 'business', 'career', 'job', 'office', 'briefcase', 'professional'] },
  { emoji: '🎯', keywords: ['goal', 'goals', 'target', 'focus', 'aim', 'objective', 'okr', 'dart', 'bullseye'] },
  { emoji: '🚀', keywords: ['rocket', 'launch', 'startup', 'project', 'ambition', 'growth', 'fast', 'speed'] },
  { emoji: '💡', keywords: ['idea', 'ideas', 'lightbulb', 'creative', 'innovation', 'brainstorm', 'bright'] },

  // Work & Productivity
  { emoji: '📊', keywords: ['chart', 'analytics', 'data', 'metrics', 'dashboard', 'stats', 'statistics', 'report'] },
  { emoji: '📈', keywords: ['graph', 'growth', 'increase', 'trending', 'up', 'progress', 'stocks', 'investment', 'trading'] },
  { emoji: '📋', keywords: ['clipboard', 'list', 'tasks', 'checklist', 'todo', 'inventory'] },
  { emoji: '📝', keywords: ['notes', 'note', 'memo', 'writing', 'document', 'edit', 'write'] },
  { emoji: '✅', keywords: ['check', 'done', 'complete', 'success', 'approved', 'yes', 'correct'] },
  { emoji: '⏰', keywords: ['clock', 'time', 'alarm', 'schedule', 'deadline', 'timer'] },
  { emoji: '📆', keywords: ['calendar', 'date', 'schedule', 'planner', 'events', 'appointment'] },
  { emoji: '🛠️', keywords: ['tools', 'build', 'fix', 'repair', 'settings', 'config', 'maintenance'] },
  { emoji: '⚙️', keywords: ['gear', 'settings', 'config', 'options', 'preferences', 'configuration'] },
  { emoji: '📌', keywords: ['pin', 'important', 'bookmark', 'save', 'mark', 'pinned'] },

  // Media & News
  { emoji: '📰', keywords: ['news', 'newspaper', 'paper', 'media', 'press', 'article', 'headlines', 'daily', 'journal'] },
  { emoji: '📺', keywords: ['tv', 'television', 'watch', 'show', 'broadcast', 'media', 'screen'] },
  { emoji: '🎙️', keywords: ['podcast', 'microphone', 'recording', 'studio', 'broadcast', 'speak'] },

  // Finance & Money
  { emoji: '💰', keywords: ['money', 'finance', 'cash', 'savings', 'wealth', 'budget', 'rich'] },
  { emoji: '💵', keywords: ['dollar', 'money', 'cash', 'payment', 'currency', 'bills'] },
  { emoji: '💳', keywords: ['credit', 'card', 'payment', 'bank', 'shopping', 'debit'] },
  { emoji: '🏦', keywords: ['bank', 'finance', 'money', 'savings', 'investment', 'financial'] },

  // Education & Learning
  { emoji: '📚', keywords: ['books', 'book', 'reading', 'study', 'learning', 'library', 'education', 'school'] },
  { emoji: '🎓', keywords: ['graduation', 'school', 'university', 'degree', 'education', 'college', 'academic'] },
  { emoji: '✏️', keywords: ['pencil', 'write', 'edit', 'draw', 'school', 'sketch'] },
  { emoji: '🧠', keywords: ['brain', 'mind', 'thinking', 'intelligence', 'knowledge', 'smart', 'mental'] },
  { emoji: '🔬', keywords: ['microscope', 'science', 'research', 'lab', 'experiment', 'biology'] },

  // Health & Fitness
  { emoji: '💪', keywords: ['muscle', 'fitness', 'gym', 'workout', 'strong', 'exercise', 'strength'] },
  { emoji: '🏃', keywords: ['running', 'run', 'exercise', 'fitness', 'cardio', 'sport', 'jog'] },
  { emoji: '🧘', keywords: ['yoga', 'meditation', 'zen', 'relax', 'mindfulness', 'wellness'] },
  { emoji: '❤️', keywords: ['heart', 'love', 'health', 'care', 'wellness', 'favorite'] },
  { emoji: '🥗', keywords: ['salad', 'healthy', 'food', 'diet', 'nutrition', 'vegetables'] },

  // Travel & Places
  { emoji: '✈️', keywords: ['plane', 'travel', 'flight', 'trip', 'vacation', 'airport', 'fly', 'airplane'] },
  { emoji: '🌍', keywords: ['world', 'earth', 'globe', 'travel', 'global', 'international', 'europe', 'africa'] },
  { emoji: '🗺️', keywords: ['map', 'world', 'travel', 'explore', 'geography', 'atlas'] },
  { emoji: '🧳', keywords: ['luggage', 'travel', 'trip', 'vacation', 'packing', 'suitcase'] },
  { emoji: '🏖️', keywords: ['beach', 'vacation', 'summer', 'holiday', 'relax', 'sand', 'tropical'] },
  { emoji: '⛰️', keywords: ['mountain', 'hiking', 'nature', 'outdoor', 'adventure', 'climb'] },
  { emoji: '🚗', keywords: ['car', 'drive', 'road', 'trip', 'vehicle', 'auto', 'driving'] },
  { emoji: '📍', keywords: ['pin', 'location', 'place', 'map', 'marker', 'address'] },

  // Nature & Environment
  { emoji: '🌿', keywords: ['nature', 'plant', 'leaf', 'green', 'eco', 'environment', 'herb'] },
  { emoji: '🌱', keywords: ['seedling', 'growth', 'plant', 'nature', 'new', 'growing', 'sprout'] },
  { emoji: '🌳', keywords: ['tree', 'nature', 'forest', 'green', 'outdoor', 'woods'] },
  { emoji: '🌸', keywords: ['flower', 'spring', 'blossom', 'nature', 'pink', 'cherry'] },
  { emoji: '🌊', keywords: ['wave', 'ocean', 'sea', 'water', 'beach', 'surf'] },
  { emoji: '☀️', keywords: ['sun', 'sunny', 'weather', 'bright', 'day', 'sunshine'] },
  { emoji: '🌙', keywords: ['moon', 'night', 'sleep', 'dream', 'evening'] },
  { emoji: '⭐', keywords: ['star', 'favorite', 'rating', 'important', 'starred'] },
  { emoji: '✨', keywords: ['sparkles', 'magic', 'special', 'new', 'clean', 'glitter'] },
  { emoji: '🔥', keywords: ['fire', 'hot', 'trending', 'popular', 'lit', 'flame'] },
  { emoji: '🌈', keywords: ['rainbow', 'colorful', 'pride', 'diversity', 'hope', 'colors'] },

  // Tech & Digital
  { emoji: '📱', keywords: ['phone', 'mobile', 'app', 'smartphone', 'device', 'iphone', 'android'] },
  { emoji: '💻', keywords: ['laptop', 'computer', 'coding', 'work', 'tech', 'programming', 'dev'] },
  { emoji: '🖥️', keywords: ['desktop', 'computer', 'monitor', 'screen', 'pc'] },
  { emoji: '🎧', keywords: ['headphones', 'music', 'audio', 'podcast', 'listen', 'earphones'] },
  { emoji: '🔒', keywords: ['lock', 'security', 'private', 'safe', 'password', 'secure', 'locked'] },
  { emoji: '🔑', keywords: ['key', 'password', 'access', 'unlock', 'security', 'login'] },
  { emoji: '🌐', keywords: ['web', 'internet', 'global', 'online', 'network', 'website', 'www'] },

  // Creative & Arts
  { emoji: '🎨', keywords: ['art', 'paint', 'design', 'creative', 'color', 'palette', 'artist'] },
  { emoji: '📷', keywords: ['camera', 'photo', 'picture', 'photography', 'snapshot'] },
  { emoji: '🎥', keywords: ['camera', 'video', 'film', 'movie', 'recording', 'cinema'] },
  { emoji: '🎬', keywords: ['movie', 'film', 'cinema', 'action', 'director', 'clapboard'] },
  { emoji: '🎵', keywords: ['music', 'note', 'song', 'melody', 'audio', 'tune'] },
  { emoji: '🎤', keywords: ['microphone', 'sing', 'karaoke', 'podcast', 'speak', 'voice'] },
  { emoji: '🎸', keywords: ['guitar', 'music', 'rock', 'instrument', 'band'] },

  // Entertainment & Fun
  { emoji: '🎮', keywords: ['game', 'gaming', 'controller', 'play', 'video', 'playstation', 'xbox'] },
  { emoji: '🎲', keywords: ['dice', 'game', 'chance', 'luck', 'board', 'random'] },
  { emoji: '🏆', keywords: ['trophy', 'winner', 'champion', 'award', 'prize', 'win', 'victory'] },
  { emoji: '🎉', keywords: ['party', 'celebration', 'confetti', 'birthday', 'fun', 'celebrate'] },
  { emoji: '🎁', keywords: ['gift', 'present', 'birthday', 'surprise', 'reward', 'box'] },
  { emoji: '🧩', keywords: ['puzzle', 'game', 'piece', 'solve', 'jigsaw', 'fit'] },

  // People & Social
  { emoji: '👥', keywords: ['people', 'group', 'team', 'users', 'community', 'members'] },
  { emoji: '👤', keywords: ['person', 'user', 'profile', 'account', 'individual'] },
  { emoji: '🤝', keywords: ['handshake', 'deal', 'agreement', 'partnership', 'meeting', 'collaborate'] },
  { emoji: '💬', keywords: ['chat', 'message', 'speech', 'talk', 'conversation', 'comment', 'discuss'] },
  { emoji: '📧', keywords: ['email', 'mail', 'inbox', 'message', 'send'] },
  { emoji: '📞', keywords: ['phone', 'call', 'telephone', 'contact', 'dial'] },

  // Food & Drink
  { emoji: '☕', keywords: ['coffee', 'cafe', 'drink', 'morning', 'espresso', 'caffeine', 'java'] },
  { emoji: '🍵', keywords: ['tea', 'green', 'drink', 'relax', 'herbal'] },
  { emoji: '🍕', keywords: ['pizza', 'food', 'italian', 'dinner', 'slice'] },
  { emoji: '🍔', keywords: ['burger', 'food', 'fast', 'lunch', 'hamburger'] },

  // Animals
  { emoji: '🐶', keywords: ['dog', 'puppy', 'pet', 'animal', 'cute', 'doggy'] },
  { emoji: '🐱', keywords: ['cat', 'kitten', 'pet', 'animal', 'cute', 'kitty'] },
  { emoji: '🦁', keywords: ['lion', 'animal', 'king', 'brave', 'wild', 'jungle'] },
  { emoji: '🦋', keywords: ['butterfly', 'insect', 'nature', 'beautiful', 'fly'] },

  // Symbols
  { emoji: '💎', keywords: ['diamond', 'gem', 'precious', 'valuable', 'jewel', 'luxury'] },
  { emoji: '⚡', keywords: ['lightning', 'electric', 'power', 'fast', 'energy', 'bolt', 'flash'] },
  { emoji: '💯', keywords: ['hundred', 'perfect', 'score', 'complete', 'full'] },
];
